import React from 'react';
import { motion } from 'framer-motion';
import { CalendarHeart } from 'lucide-react';
export function ValentinesSection() {
  return <section className="py-20 bg-[#FAF7F2] text-[#0A0A0A]" data-id="element-155">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-157">
          <div className="flex items-center gap-3 mb-6" data-id="element-158">
            <CalendarHeart className="w-8 h-8 text-[#B91C1C]" data-id="element-159" />
            <h2 className="text-3xl font-serif font-bold text-[#0A0A0A]" data-id="element-160">
              El 14 de febrero como nuevo comenzar
            </h2>
          </div>

          <p className="text-lg text-[#333] mb-6 leading-relaxed" data-id="element-161">
            Este 14 de febrero no tiene que ser una fecha más.
          </p>
          <p className="text-xl font-serif italic text-[#B91C1C] mb-8" data-id="element-162">
            Puede ser el punto donde decidan que su relación, en lugar de
            enfriarse con los años, entre en su mejor momento.
          </p>
          <p className="text-lg font-medium text-[#0A0A0A]" data-id="element-163">
            No es el regalo. Es el significado detrás del regalo.
          </p>
        </motion.div>

        <motion.div className="bg-white p-8 rounded-lg shadow-xl border border-[#C5A55A]/30 relative" initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-164">
          <div className="absolute -top-3 -left-3 bg-[#C5A55A] text-white text-xs font-bold px-3 py-1 uppercase tracking-widest rounded-sm" data-id="element-165">
            Dato real
          </div>
          <h3 className="text-lg font-bold text-[#0A0A0A] mb-4 mt-2" data-id="element-166">
            Psicología positiva
          </h3>
          <p className="text-[#555] leading-relaxed" data-id="element-167">
            Las parejas que crean rituales conscientes de reconexión (no
            automáticos) reportan mayor satisfacción relacional a largo plazo
            que aquellas que solo celebran fechas sin intención.
          </p>
        </motion.div>
      </div>
    </section>;
}